import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises/ports";

export default {
  fetch(portId) {
    return http.get(`${resource}/${portId}/team_leaders`);
  },

  update(portId, itemId, payload) {
    return http.put(`${resource}/${portId}/team_leaders/${itemId}`, payload);
  },

  updateOrders(portId, payload) {
    return http.put(`${resource}/${portId}/team_leaders/sorts`, payload);
  },

  add(portId, payload) {
    return http.post(`${resource}/${portId}/team_leaders`, payload);
  },

  delete(portId, itemId) {
    return http.delete(`${resource}/${portId}/team_leaders/${itemId}`);
  },
};
